export default "__VITE_ASSET__ChoU4yRd__"